import ContactPill from './ContactPill';

export default ContactPill;
